// import Stomp, { Client } from 'webstomp-client';
// import SockJs from 'sockjs-client/dist/sockjs';
//
// import { mapNotification, WebSocketTopics } from '@/shared/services/notification';
// import { useNotificationStore } from '@/app/stores/notification';
//
// let stomp: Client | null = null;
// let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
//
// const connectSocket = () => {
//   stomp = Stomp.over(new SockJs(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/notification-service/ob-ws`));
//   if (import.meta.env.MODE !== 'development') stomp.debug = () => {};
//
//   const onConnect = () => {
//     if (reconnectTimer) {
//       clearTimeout(reconnectTimer);
//       reconnectTimer = null;
//     }
//
//     stomp?.subscribe(WebSocketTopics.USER_NOTIFICATION, (message) => {
//       const notifications = JSON.parse(message.body);
//       const result = mapNotification(notifications);
//       const { addNotifications } = useNotificationStore();
//       addNotifications(result);
//     });
//   };
//
//   const onError = () => {
//     if (!reconnectTimer) {
//       reconnectTimer = setTimeout(() => {
//         reconnectTimer = null;
//         connectSocket();
//       }, 5000);
//     }
//   };
//
//   stomp.connect({}, onConnect, onError);
// };
//
// const disconnectSocket = () => {
//   if (stomp?.connected) stomp.disconnect();
//   if (reconnectTimer) {
//     clearTimeout(reconnectTimer);
//     reconnectTimer = null;
//   }
// };
//
// export { disconnectSocket, connectSocket };

import Stomp, { Client } from 'webstomp-client';
import SockJs from 'sockjs-client/dist/sockjs';
import { mapNotification, WebSocketTopics } from '@/shared/services/notification';
import { useNotificationStore } from '@/app/stores/notification';
let stomp: Client | null = null;
const connectSocket = () => {
  stomp = Stomp.over(new SockJs(`${import.meta.env.VITE_APP_ENDPOINT}/mobile/notification-service/ob-ws`));
  if (import.meta.env.MODE !== 'development') stomp.debug = () => {};
  stomp.connect({}, () => {
    stomp?.subscribe(WebSocketTopics.USER_NOTIFICATION, (message) => {
      const notifications = JSON.parse(message.body);
      const result = mapNotification(notifications);
      const { addNotifications } = useNotificationStore();
      addNotifications(result);
    });
  });
};
const disconnectSocket = () => {
  if (stomp?.connected) stomp.disconnect();
};

export { disconnectSocket, connectSocket };
